import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';

interface SettingsPageLayoutProps {
  title: string;
  onBack?: () => void;
  children: React.ReactNode;
  showBackButton?: boolean;
}

/**
 * 统一的设置页面布局组件
 * 处理安全区域避让、页面标题、返回按钮等通用布局需求
 */
export const SettingsPageLayout: React.FC<SettingsPageLayoutProps> = ({
  title,
  onBack,
  children,
  showBackButton = true,
}) => {
  return (
    <div className="min-h-screen bg-ios-gray6 dark:bg-ios-dark-gray6 pt-[env(safe-area-inset-top)] pb-16 font-ios">
      {/* 统一的页面标题栏 */}
      <div className="flex items-center mb-6 px-4 pt-6">
        {showBackButton && onBack && (
          <button
            onClick={onBack}
            className="p-2 -ml-2 text-ios-blue dark:text-ios-dark-blue"
          >
            <FaArrowLeft className="w-5 h-5" />
          </button>
        )}
        <h1 className="ml-2 text-ios-title2 font-semibold">
          {title}
        </h1>
      </div>
      
      {/* 内容区域 */}
      <div className="px-4">
        {children}
      </div>
    </div>
  );
};
